import { Component, OnInit } from '@angular/core';
import { EquipmentRequest } from '../../../../services/equipment-request/equipment-request.interface';
import { EquipmentRequestService } from '../../../../services/equipment-request/equipment-request.service';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { FormsModule, ReactiveFormsModule, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { Router } from '@angular/router';

@Component({
    selector: 'app-equipment-request-form',
    imports: [
    MatProgressBarModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    MatDatepickerModule,
    RouterModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule
],
    templateUrl: './equipment-request-form.component.html',
    styleUrl: './equipment-request-form.component.css'
})
export class EquipmentRequestFormComponent implements OnInit {
  currentStep = 1;
  formId: string | null = null;
  equipmentRequestListId: string | null = null;
  loadingSection1 = false;
  loadingSection2 = false;
  loadingSection3 = false;
  loadingSection4 = false;
  form: FormGroup;

  operationsManagers = [
    { name: 'Samira Richardson', email: 'srichardson@landpoint.net' },
    { name: 'Josh Hazen', email: 'jhazen@landpoint.net' },
    { name: 'Jake Pharis', email: 'jpharis@landpoint.net' },
    { name: 'Jeff Solberg', email: 'jsolberg@landpoint.net' },
    { name: 'Joanna Surgenor', email: 'jsurgenor@landpoint.net' },
    { name: 'Patrick Turner', email: 'pturner@landpoint.net' },
  ];

  onOperationsManagerSelected(email: string): void {
    const manager = this.operationsManagers.find((m) => m.email === email);
    this.form.get('section1.operationsManager')?.setValue(manager ? manager.name : '');
  }

  // isTrue = true;
  // isFalse = false;

  constructor(private fb: FormBuilder, private equipmentRequestFormService: EquipmentRequestService, private route: ActivatedRoute, private router: Router) {}

  calculateProgress(): number {
    const completedSections = [
      this.form.value?.section1.employeeCompleted,
      this.form.value?.section2.supervisorCompleted,
      this.form.value?.section3.opsManagerCompleted,
      this.form.value?.section4.techDirectorCompleted,
    ].filter(Boolean).length;
    return (completedSections / 4) * 100;
  }

  get supervisorRejected(): boolean {
    return this.form.value?.section2.supervisorApproval === false;
  }

  get opsManagerRejected(): boolean {
    return this.form.value?.section3.opsManagerApproval === false;
  }
  
  get techDirectorRejected(): boolean {
    return this.form.value?.section4.techDirectorApproval === false;
  }

  configureValidatorsForCurrentStep(): void {
    if (this.currentStep === 2) {
      this.form.get('section2.supervisorSignature')?.setValidators([Validators.required]);
    } else if (this.currentStep === 3) {
      this.form.get('section3.opsManagerSignature')?.setValidators([Validators.required]);
    } else if (this.currentStep === 4) {
      this.form.get('section4.techDirectorSignature')?.setValidators([Validators.required]);
    }
  }

  loadForm(formId: string): void {
    this.equipmentRequestFormService.getForm(formId).subscribe(
      (response) => {
        this.form.patchValue(response['data']);
        this.setCurrentStep();
        this.configureValidatorsForCurrentStep();
        // this.loadEquipmentRequestList(formId); 
      },
      (error) => {
        console.error('Error fetching form data:', error);
      }
    );
  }
  
  // loadEquipmentRequestList(formId: string): void {
  //   this.equipmentRequestFormService.findAllEquipmentRequest().subscribe(
  //     (response) => {
  //       const equipmentRequestLists = response?.data || [];
  //       const matchingList = equipmentRequestLists.find((list: any) => list.indexId === formId);
  //       this.equipmentRequestListId = matchingList?._id || null;
  //     },
  //     (error) => {
  //       console.error('Error fetching equipment request list data:', error);
  //     }
  //   );
  // }

  moveToNextStep(): void {
    if (this.currentStep <= 4) {
      this.currentStep++;
      this.configureValidatorsForCurrentStep();
    }
  }

  ngOnInit(): void {
    // Create local date string to use in form initialization
    const now: Date = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const localYYYYMMDD = `${yyyy}-${mm}-${dd}`;

    this.form = this.fb.group({
      section1: this.fb.group({
          requestDate: [localYYYYMMDD, Validators.required],
          employeeName: ['', Validators.required],
          employeeEmail: ['', [Validators.required, Validators.email]],
          jobTitle: ['', Validators.required],
          department: '',
          reportingOffice: '',
          supervisor: ['', Validators.required],
          supervisorEmail: ['', [Validators.required, Validators.email]],
          operationsManager: ['', Validators.required],
          operationsManagerEmail: ['', [Validators.required, Validators.email]],
          reasonForRequest: ['', Validators.required],
          currentComputerType: ['', Validators.required],
          requestedComputerType: ['', Validators.required],
          currentEdition: '',
          currentProcessor: '',
          currentInstalledRam: '',
          currentStorage: '',
          currentGraphicsCard: '',
          requestedComputerSpecs: ['', Validators.required],
          otherSpecialRequests: '',
          employeeSignature: ['', Validators.required],
          employeeCompleted: false,
      }),
      section2: this.fb.group({
          supervisorApproval: [true, Validators.required],
          supervisorRejectionReason: '',
          supervisorSignature: '',
          supervisorSignedDate: localYYYYMMDD,
          supervisorCompleted: false,
      }),
      section3: this.fb.group({
          opsManagerApproval: [true, Validators.required],
          opsManagerRejectionReason: '',
          opsManagerSignature: '',
          opsManagerSignedDate: localYYYYMMDD,
          opsManagerCompleted: false,
      }),
      section4: this.fb.group({
          techDirectorApproval: [true, Validators.required],
          techDirectorRejectionReason: '',
          techDirectorSignature: '',
          techDirectorSignedDate: localYYYYMMDD,
          techDirectorCompleted: false,
      }),
    });

    // Watch for supervisor approval changes to conditionally show and require rejection reason
    this.form.get('section2.supervisorApproval')?.valueChanges.subscribe((value) => {
      const rejectionReasonControl = this.form.get('section2.supervisorRejectionReason');
      if (value === false) {
        rejectionReasonControl?.setValidators([Validators.required]);
        rejectionReasonControl?.updateValueAndValidity();
      } else {
        rejectionReasonControl?.clearValidators();
        rejectionReasonControl?.updateValueAndValidity();
      }
    });

    // Watch for ops manager approval changes to conditionally show and require rejection reason
    this.form.get('section3.opsManagerApproval')?.valueChanges.subscribe((value) => {
      const rejectionReasonControl = this.form.get('section3.opsManagerRejectionReason');
      if (value === false) {
        rejectionReasonControl?.setValidators([Validators.required]);
        rejectionReasonControl?.updateValueAndValidity();
      } else {
        rejectionReasonControl?.clearValidators();
        rejectionReasonControl?.updateValueAndValidity();
      }
    });

    // Watch for tech director approval changes to conditionally show and require rejection reason
    this.form.get('section4.techDirectorApproval')?.valueChanges.subscribe((value) => {
      const rejectionReasonControl = this.form.get('section4.techDirectorRejectionReason');
      if (value === false) {
        rejectionReasonControl?.setValidators([Validators.required]);
        rejectionReasonControl?.updateValueAndValidity();
      } else {
        rejectionReasonControl?.clearValidators();
        rejectionReasonControl?.updateValueAndValidity();
      }
    });

    this.route.paramMap.subscribe((params) => {
      this.formId = params.get('id'); 
      if (this.formId) {
        this.loadForm(this.formId);
      } else {
        this.setCurrentStep();
        this.configureValidatorsForCurrentStep();
      }
    });
  }
  
  setCurrentStep(): void {
    if (this.form.value?.section4.techDirectorCompleted) {
      this.currentStep = 0; 
    } else if (this.form.value?.section1.employeeCompleted && this.form.value?.section2.supervisorCompleted && this.form.value?.section3.opsManagerCompleted && !this.form.value?.section4.techDirectorCompleted) {
      this.currentStep = 4; 
    } else if (this.form.value?.section1.employeeCompleted && this.form.value?.section2.supervisorCompleted && !this.form.value?.section3.opsManagerCompleted) {
      this.currentStep = 3; 
    } else if (this.form.value?.section1.employeeCompleted && !this.form.value?.section2.supervisorCompleted) {
      this.currentStep = 2; 
    } else {
      this.currentStep = 1; 
    }
  }

  saveSection1(): void {
    if (this.form.invalid) {
      return;
    }
    if (this.form.value?.section1.employeeCompleted) {
        console.warn('Section 1 is already completed. Cannot re-submit.');
        return;
    }
    this.loadingSection1 = true;
    const section1ControlValues: EquipmentRequest = {
      section1: {
        requestDate: this.form.value.section1.requestDate,
        employeeName: this.form.value.section1.employeeName,
        employeeEmail: this.form.value.section1.employeeEmail,
        jobTitle: this.form.value.section1.jobTitle,
        department: this.form.value.section1.department,
        reportingOffice: this.form.value.section1.reportingOffice,
        supervisor: this.form.value.section1.supervisor,
        supervisorEmail: this.form.value.section1.supervisorEmail,
        operationsManager: this.form.value.section1.operationsManager,
        operationsManagerEmail: this.form.value.section1.operationsManagerEmail,
        reasonForRequest: this.form.value.section1.reasonForRequest,
        currentComputerType: this.form.value.section1.currentComputerType,
        requestedComputerType: this.form.value.section1.requestedComputerType,
        currentEdition: this.form.value.section1.currentEdition,
        currentProcessor: this.form.value.section1.currentProcessor,
        currentInstalledRam: this.form.value.section1.currentInstalledRam,
        currentStorage: this.form.value.section1.currentStorage,
        currentGraphicsCard: this.form.value.section1.currentGraphicsCard,
        requestedComputerSpecs: this.form.value.section1.requestedComputerSpecs,
        otherSpecialRequests: this.form.value.section1.otherSpecialRequests,
        employeeSignature: this.form.value.section1.employeeSignature,
        employeeCompleted: true,
      },
      section2: {
        supervisorApproval: false,
        supervisorSignature: '',
        supervisorSignedDate: '',
        supervisorCompleted: false,
      },
      section3: {
        opsManagerApproval: false,
        opsManagerSignature: '',
        opsManagerSignedDate: '',
        opsManagerCompleted: false,
      },
      section4: {
        techDirectorApproval: false,
        techDirectorSignature: '',
        techDirectorSignedDate: '',
        techDirectorCompleted: false,
      },
    };
    this.equipmentRequestFormService.createForm(section1ControlValues).subscribe(
      (response) => {
        this.formId = response.data._id; 
        this.form.get('section1.employeeCompleted')?.setValue(true);
        this.router.navigate(['success']);
        this.loadingSection1 = false;
        this.moveToNextStep();
      },
      (error) => {
        console.error('Error saving section 1:', error);
        this.loadingSection1 = false;
      }
    );
  }

  saveSection2(): void {
    if (this.form.value?.section2.supervisorCompleted) {
        console.warn('Section 2 is already completed. Cannot re-submit.');
        return;
    }
    this.loadingSection2 = true;
    const section2ControlValues: EquipmentRequest = {
      section1: {
        requestDate: '',
        employeeName: '',
        employeeEmail: '',
        jobTitle: '',
        department: '',
        reportingOffice: '',
        supervisor: '',
        supervisorEmail: '',
        operationsManager: '',
        operationsManagerEmail: '',
        reasonForRequest: '',
        currentComputerType: '',
        requestedComputerType: '',
        currentEdition: '',
        currentProcessor: '',
        currentInstalledRam: '',
        currentStorage: '',
        currentGraphicsCard: '',
        requestedComputerSpecs: '',
        otherSpecialRequests: '',
        employeeSignature: '',
        employeeCompleted: false,
      },
      section2: {
        supervisorApproval: this.form.value.section2.supervisorApproval,
        supervisorSignature: this.form.value.section2.supervisorSignature,
        supervisorSignedDate: this.form.value.section2.supervisorSignedDate,
        supervisorCompleted: true,
      },
      section3: {
        opsManagerApproval: false,
        opsManagerSignature: '',
        opsManagerSignedDate: '',
        opsManagerCompleted: false,
      },
      section4: {
        techDirectorApproval: false,
        techDirectorSignature: '',
        techDirectorSignedDate: '',
        techDirectorCompleted: false,
      },
    };
    this.equipmentRequestFormService.updateSection2(this.formId, section2ControlValues.section2).subscribe(
      (response) => {
        this.form.get('section2.supervisorCompleted')?.setValue(true);
        this.router.navigate(['success']);
        this.loadingSection2 = false;
        this.moveToNextStep();
      },
      (error) => {
        console.error('Error saving section 2:', error);
        this.loadingSection2 = false;
      }
    );
  }

  saveSection3(): void {
    if (this.form.value?.section3.opsManagerCompleted) {
        console.warn('Section 3 is already completed. Cannot re-submit.');
        return;
    }
    this.loadingSection3 = true;
    const section3ControlValues: EquipmentRequest = {
      section1: {
        requestDate: '',
        employeeName: '',
        employeeEmail: '',
        jobTitle: '',
        department: '',
        reportingOffice: '',
        supervisor: '',
        supervisorEmail: '',
        operationsManager: '',
        operationsManagerEmail: '',
        reasonForRequest: '',
        currentComputerType: '',
        requestedComputerType: '',
        currentEdition: '',
        currentProcessor: '',
        currentInstalledRam: '',
        currentStorage: '',
        currentGraphicsCard: '',
        requestedComputerSpecs: '',
        otherSpecialRequests: '',
        employeeSignature: '',
        employeeCompleted: false,
      },
      section2: {
        supervisorApproval: false,
        supervisorSignature: '',
        supervisorSignedDate: '',
        supervisorCompleted: false,
      },
      section3: {
        opsManagerApproval: this.form.value.section3.opsManagerApproval,
        opsManagerSignature: this.form.value.section3.opsManagerSignature,
        opsManagerSignedDate: this.form.value.section3.opsManagerSignedDate,
        opsManagerCompleted: true,
      },
      section4: {
        techDirectorApproval: false,
        techDirectorSignature: '',
        techDirectorSignedDate: '',
        techDirectorCompleted: false,
      },
    };
    this.equipmentRequestFormService.updateSection3(this.formId, section3ControlValues.section3).subscribe(
      (response) => {
        this.form.get('section3.opsManagerCompleted')?.setValue(true);
        this.router.navigate(['success']);
        this.loadingSection3 = false;
        this.moveToNextStep();
      },
      (error) => {
        console.error('Error saving section 3:', error);
        this.loadingSection3 = false;
      }
    );
  }

  saveSection4(): void {
      if (this.form.value?.section4.techDirectorCompleted) {
          console.warn('Section 4 is already completed. Cannot re-submit.');
          return;
      }
    this.loadingSection4 = true; 
    const section4ControlValues: EquipmentRequest = {
      section1: {
        requestDate: '',
        employeeName: '',
        employeeEmail: '',
        jobTitle: '',
        department: '',
        reportingOffice: '',
        supervisor: '',
        supervisorEmail: '',
        operationsManager: '',
        operationsManagerEmail: '',
        reasonForRequest: '',
        currentComputerType: '',
        requestedComputerType: '',
        currentEdition: '',
        currentProcessor: '',
        currentInstalledRam: '',
        currentStorage: '',
        currentGraphicsCard: '',
        requestedComputerSpecs: '',
        otherSpecialRequests: '',
        employeeSignature: '',
        employeeCompleted: false,
      },
      section2: {
        supervisorApproval: false,
        supervisorSignature: '',
        supervisorSignedDate: '',
        supervisorCompleted: false,
      },
      section3: {
        opsManagerApproval: false,
        opsManagerSignature: '',
        opsManagerSignedDate: '',
        opsManagerCompleted: false,
      },
      section4: {
        techDirectorApproval: this.form.value.section4.techDirectorApproval,
        techDirectorSignature: this.form.value.section4.techDirectorSignature,
        techDirectorSignedDate: this.form.value.section4.techDirectorSignedDate,
        techDirectorCompleted: true,
      },
    };
    this.equipmentRequestFormService.updateSection4(this.formId, section4ControlValues.section4).subscribe(
      (response) => {
        this.form.get('section4.techDirectorCompleted')?.setValue(true);
        this.router.navigate(['success']);
        this.loadingSection4 = false;
      },
      (error) => {
        console.error('Error saving section 4:', error);
        this.loadingSection4 = false;
      }
    );
  }
}
